import {
  primaryColors,
  whiteShades,
  transparentColors
} from '@/assets/styles/helpers/colors.styles'

export const sliderStyles = {
  '&.MuiSlider-root': {
    padding: '1rem 0'
  },
  '.MuiSlider-mark': {
    width: '0.5rem',
    height: '0.5rem',
    borderRadius: '0.5rem',
    backgroundColor: primaryColors.white,
    opacity: 1,
    '&:first-of-type': {
      display: 'none'
    }
  },
  '.MuiSlider-markActive': {
    width: '0.5rem',
    height: '0.5rem',
    borderRadius: '0.5rem',
    backgroundColor: primaryColors.orange,
    opacity: 1
  },
  '.MuiSlider-track': {
    backgroundColor: primaryColors.orange,
    border: 'none',
    borderRadius: 0
  },
  '.MuiSlider-rail': {
    backgroundColor: whiteShades.shade1,
    borderRadius: 0
  },
  '.MuiSlider-thumb': {
    backgroundColor: primaryColors.orange,
    boxShadow: 'none',
    width: '1rem',
    height: '1rem',
    '&.Mui-focusVisible': {
      boxShadow: '0px 0px 0px 8px rgba(255, 101, 0, 0.2)'
    },

    '&:hover': {
      boxShadow: '0px 0px 0px 8px rgba(255, 101, 0, 0.2)'
    },
    '&.Mui-active': {
      boxShadow: '0px 0px 0px 8px rgba(255, 101, 0, 0.3)'
    },
    '&::before': {
      boxShadow: 'none'
    },
    '&::after': {
      width: '2rem',
      height: '2rem'
    },
    '.MuiSlider-valueLabel': {
      transform: 'translateY(calc(-100% + 0.25rem)) scale(1)',
      '&:before': {
        content: 'none'
      }
    }
  },
  '.MuiSlider-valueLabel': {
    backgroundColor: transparentColors.transparent,
    fontWeight: 900,
    fontFamily: 'helvetica-neue-lt-pro-cond',
    fontSize: '1rem'
  }
}
